import styled from "styled-components";

export const StyledManageArchiving = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;

  & > .text-switch-container {
    margin: 32px 0 0 20px;
  }

  & > .archiving-all-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
  }

  & > .nothing-to-archive-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin: 0 32px;
  }
`;

export const StyledAlertMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;
